<div class="container" cdkFocusInitial aria-modal="true">
  <div mat-dialog-title class="dialog-title" style="margin-left: 10px;">
    <h1>Request BARC Image</h1>
    <button mat-icon-button aria-label="close dialog" mat-dialog-close aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    @if (barcRequested) {
      <div class="yellow-box">
        <div class="container_message">
          <i class="material-icons check-icon">warning</i>

          <div class="subcontainer_message">
            <div class="title">
              <b>BARC Image has already been requested!</b>
            </div>
            <p class="subtitle margin-bottom-1">If you have any questions about this request please contact <a href="mailto:sm.fs.baerimagery@usda.gov">sm.fs.baerimagery@usda.gov</a></p>
          </div>
        </div>
      </div>
    }
    <p class="subtitle">
      If the 2500-8 report type is a "Funding Request for Emergency Stabilization Funds"
      please fill out the details below to request the BARC (Burned Area Reflection Classification)
      image. Refer to the 209 Report or <a target="_blank"
      href="https://www.nifc.gov/nicc/incident-information/national-incident-map">IMSR
      Map
      <fa-icon [icon]="faArrowUpRightFromSquare"
      class="fa-regular fa-green" aria-label="close"></fa-icon>
    </a> to
    get details for the fields.
  </p>
  <div class="title" style="margin-bottom: 20px;font-size: 17px !important;">BAER Assessment Details</div>
  <form id="filter_form" class="filter_form" [formGroup]="barcForm">
    <div class="grid-container width-full padding-x-0 margin-bottom-4">
      <div class="grid-row">
        <div class="tablet:grid-col-6 grid-col">
          <div class="title">Fire Name</div>
          <p class="text">{{ fireRecord?.baer_name ?? '--' }}</p>
        </div>
        <div class="tablet:grid-col-6 grid-col">
          <div class="title"><span class="red">*</span>Fire ID</div>
          <mat-form-field class="text-area" appearance="outline" subscriptSizing="dynamic">
            <input matInput formControlName="fire_id" placeholder="e.g. 2024-COWEX-000679"
              required
              pattern="[A-Za-z0-9]{4}-[A-Za-z0-9]{5}-[A-Za-z0-9]{6}"
              mask="AAAA-AAAAA-AAAAAA"
              [dropSpecialCharacters]="false"
              >
              @if (barcForm.get('fire_id')?.hasError('required') && barcForm.get('fire_id')?.touched) {
                <mat-error
                  >Fire ID is required
                </mat-error>
              }
              @if (barcForm.get('fire_id')?.hasError('pattern') && barcForm.get('fire_id')?.dirty || barcForm.get('fire_id')?.touched) {
                <mat-error
                  >Fire ID must match format YYYY-XXXXX-XXXXXX, e.g. 2024-COWEX-000679
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="grid-container width-full padding-x-0 margin-bottom-4">
        <div class="grid-row">
          <div class="tablet:grid-col-6 grid-col">
            <div class="title"><span class="red">*</span>Latitude (in DD xx.xxx)</div>
            <mat-form-field class="text-area" appearance="outline" subscriptSizing="dynamic">
              <input matInput formControlName="lat" placeholder="e.g. 00.000000" required
                pattern="^(\+|-)?(?:90(\.0{3,})?|[0-8]?\d(\.\d{3,})?)$"
                >
                @if (barcForm.get('lat')?.hasError('required') && barcForm.get('lat')?.touched) {
                  <mat-error
                    >Latitude is required
                  </mat-error>
                }
                @if (barcForm.get('lat')?.hasError('pattern') && barcForm.get('lat')?.dirty || barcForm.get('lat')?.touched) {
                  <mat-error
                    >Latitude must be a decimal number between -90 and 90, for example: 28.538
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="tablet:grid-col-6 grid-col">
              <div class="title"><span class="red">*</span>Longitude (in DD -xx.xxx)</div>
              <mat-form-field class="text-area" appearance="outline" subscriptSizing="dynamic">
                <input matInput formControlName="lon" placeholder="e.g. 00.000000" required
                  pattern="^[-+]?(?:180(?:\.0{3,})?|(?:1[0-7]\d|[1-9]?\d)(?:\.\d{3,})?)$"
                  >
                  @if (barcForm.get('lon')?.hasError('required') && barcForm.get('lon')?.touched) {
                    <mat-error
                      >Longitude is required
                    </mat-error>
                  }
                  @if (barcForm.get('lon')?.hasError('pattern') && barcForm.get('lon')?.dirty || barcForm.get('lon')?.touched) {
                    <mat-error
                      >Longitude must be a decimal number between -180 and 180, for example: -115.837
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="grid-container width-full padding-x-0 margin-bottom-4">
            <div class="grid-row">
              <div class="tablet:grid-col-6 grid-col">
                <div class="title">Agency</div>
                <p class="text">USFS</p>
              </div>
              <div class="tablet:grid-col-6 grid-col">
                <div class="title"><span class="red">*</span>Ignition Date (Fire Start Date)</div>
                <mat-form-field class="text-area" appearance="outline" subscriptSizing="dynamic">
                  <input matInput formControlName="ignition_date" required [matDatepicker]="picker"
                    placeholder="MM/dd/yyyy" aria-label="Fire Start Date">
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    @if (barcForm.get('ignition_date')?.hasError('required') && barcForm.get('ignition_date')?.touched) {
                      <mat-error
                        >Ignition Date is required
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="grid-container width-full padding-x-0 margin-bottom-4">
              <div class="grid-row">
                <div class="tablet:grid-col-6 grid-col">
                  <div class="title"><span class="red">*</span>Burned Acres</div>
                  <mat-form-field class="text-area" appearance="outline" subscriptSizing="dynamic">
                    <input matInput
                      formControlName="burned_acres"
                      placeholder="e.g. 12,345"
                      required
                      mask="separator"
                      [thousandSeparator]="','"
                      [decimalMarker]="'.'"
                      [dropSpecialCharacters]="true"
                      [allowNegativeNumbers]="false"
                      >
                      @if (barcForm.get('burned_acres')?.hasError('required') && barcForm.get('burned_acres')?.touched) {
                        <mat-error
                          >Burned Acres is required
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="tablet:grid-col-6 grid-col">
                    <div class="title"><span class="red">*</span>Expected Containment Date</div>
                    <mat-form-field class="text-area" appearance="outline" subscriptSizing="dynamic">
                      <input matInput formControlName="expected_containment_date" required [matDatepicker]="picker2"
                        placeholder="MM/dd/yyyy" aria-label="Containment Date">
                        <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                        @if (barcForm.get('expected_containment_date')?.hasError('required') && barcForm.get('expected_containment_date')?.touched) {
                          <mat-error
                            >Expected Containment Date is required
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <div class="grid-container width-full padding-x-0 margin-bottom-4">
                  <div class="grid-row">
                    <div class="tablet:grid-col-6 grid-col">
                      <div class="title">Assessment Start Date</div>
                      <p class="text">{{ fireRecord.tentative_start_week | date:"MM/dd/yyyy" }}</p>
                    </div>
                    <div class="tablet:grid-col-6 grid-col">
                      <div class="title">Assessment Team Leader</div>
                      <p class="text">{{ fireRecord.team_lead?.first_name + ' ' + fireRecord.team_lead?.last_name }}</p>
                    </div>
                  </div>
                </div>

                <div class="whole-line-column">
                  <div class="title">Comments</div>
                  <mat-form-field class="text-area" appearance="outline" style="max-width: 98%;">
                    <textarea matInput formControlName="comments" placeholder="Enter description"></textarea>
                  </mat-form-field>
                </div>

                @if (fireRecord.source === 'MERGE') {
                  <div class="whole-line-column">
                    <div class="title margin-bottom-2">Additional details about fire(s) in this fire complex:</div>
                    <div style="width: 98%; margin-left:10px;">
                      <mat-accordion [togglePosition]="'before'">
                        <mat-expansion-panel hideToggle="true" #fireTableExp expanded>
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              @if (!fireTableExp.expanded) {
                                <mat-icon>chevron_right</mat-icon>
                              }
                              @if (fireTableExp.expanded) {
                                <mat-icon>expand_more</mat-icon>
                              }
                              Merged Fires ({{ mergeList.length || 0 }})
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <table mat-table [dataSource]="mergeList">
                            <ng-container matColumnDef="BAER_name">
                              <th mat-header-cell *matHeaderCellDef>Fire/Complex Name</th>
                              <td mat-cell *matCellDef="let fire">{{ fire.baer_name ?? '--' }}</td>
                              <td mat-footer-cell *matFooterCellDef>Total Acres</td>
                            </ng-container>
                            <ng-container matColumnDef="forestOrgCode">
                              <th mat-header-cell *matHeaderCellDef>ForestOrg Code</th>
                              <td mat-cell *matCellDef="let fire">{{ fire.forest_org_code ?? '--' }}</td>
                              <td mat-footer-cell *matFooterCellDef></td>
                            </ng-container>
                            <ng-container matColumnDef="fireId">
                              <th mat-header-cell *matHeaderCellDef>Fire ID</th>
                              <td mat-cell *matCellDef="let fire">{{ fire.IRWIN_unique_fire_identifier ?? '--' }}</td>
                              <td mat-footer-cell *matFooterCellDef></td>
                            </ng-container>
                            <ng-container matColumnDef="containment_date">
                              <th mat-header-cell *matHeaderCellDef>Containment Date (GIS)</th>
                              <td mat-cell *matCellDef="let fire">{{ (fire.containment_date | date:"MM/dd/yyyy") ?? '--' }}</td>
                              <td mat-footer-cell *matFooterCellDef></td>
                            </ng-container>
                            <ng-container matColumnDef="lat">
                              <th mat-header-cell *matHeaderCellDef>Latitude</th>
                              <td mat-cell *matCellDef="let fire">{{ fire.initial_latitude ?? '--' }}</td>
                              <td mat-footer-cell *matFooterCellDef></td>
                            </ng-container>
                            <ng-container matColumnDef="lon">
                              <th mat-header-cell *matHeaderCellDef>Longitude</th>
                              <td mat-cell *matCellDef="let fire">{{ fire.initial_longitude ?? '--' }}</td>
                              <td mat-footer-cell *matFooterCellDef></td>
                            </ng-container>
                            <ng-container matColumnDef="est_nfs_acres">
                              <th mat-header-cell *matHeaderCellDef>Est. NFS Acres</th>
                              <td mat-cell *matCellDef="let fire">{{ (fire.acres_fsonly | number: '1.0-0') ?? '--' }}</td>
                              <td mat-footer-cell *matFooterCellDef> {{ (est_nfs_acres_total | number: '1.0-0') ?? '--' }}</td>
                            </ng-container>
                            <ng-container matColumnDef="fire_acres">
                              <th mat-header-cell *matHeaderCellDef>Total Fire Acres</th>
                              <td mat-cell *matCellDef="let fire">{{ (fire.poly_acres | number: '1.0-0') ?? '--' }}</td>
                              <td mat-footer-cell *matFooterCellDef> {{ (total_fire_acres_total | number: '1.0-0') ?? '--' }}</td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                            <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
                          </table>
                        </mat-expansion-panel>
                      </mat-accordion>
                    </div>
                  </div>
                }

              </form>
            </mat-dialog-content>
            <div mat-dialog-actions>
              <div class="button-row">
                <button aria-label="Cancel" class="usa-button usa-button--secondary" mat-dialog-close >Cancel</button>
                <button aria-label="Update" class="usa-button"
                  [disabled]="barcForm.invalid || barcRequested"
                  (click)="onSubmit()"
                  >Submit Request
                </button>
              </div>
            </div>
          </div>
